const set = (prop) => (state, payload) => {
  state[prop] = payload;
};

export default {
  setActions: set('actions'),
};
